import { render, staticRenderFns } from "./userCardList.vue?vue&type=template&id=81500baa&scoped=true"
import script from "./userCardList.vue?vue&type=script&lang=js"
export * from "./userCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81500baa",
  null
  
)

export default component.exports